import { useCallback, useEffect, useRef, useState } from 'react'

import { navigate, useLocation } from '@redwoodjs/router'

export const usePage = (): [number, (newPage: number) => void] => {
  const { search } = useLocation()

  const parsePage = (params: URLSearchParams) => {
    const parsed = parseInt(params.get('page'), 10)
    return parsed > 0 ? parsed : 1
  }

  const [page, setPageState] = useState(() =>
    parsePage(new URLSearchParams(search))
  )

  // Keep a ref so setPage always reads the latest page without needing
  // to be recreated (avoids stale closures when used in useCallback deps)
  const pageRef = useRef(page)
  pageRef.current = page

  const setPage = useCallback((newPage: number) => {
    const sanitized = newPage > 0 ? newPage : 1
    if (pageRef.current !== sanitized) {
      const params = new URLSearchParams(window.location.search)
      params.set('page', sanitized.toString())
      navigate(`?${params.toString()}`)
      setPageState(sanitized)
    }
  }, [])

  useEffect(() => {
    setPageState(parsePage(new URLSearchParams(search)))
  }, [search])

  return [page, setPage]
}

export default usePage
